// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3V3Kq6","tagTtem":"tagTtem--2f7rer","title":"title--2NqMBr","value":"value--220bE6"};